import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import StoreActions from '../../actions/StoreActions';
import InventoryRecordStore from '../../stores/InventoryRecordStore';
import StoreStore from '../../stores/StoreStore';
import StoreCard from '../../components/StoreCard';
import styles from './index.sass';

class MarketingStoresListContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = _.extend({
      loading: false
    }, this.getStateFromProps(props));
    this.handleScroll = this.handleScroll.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this.getStateFromProps(nextProps));
  }

  getStateFromProps(props) {
    let state = {};
    if(props.hasOwnProperty('loading')) {
      state.loading = props.loading;
    }
    return state;
  }

  handleScroll(e) {
    if(this.state.loading || this.props.stores.size >= this.props.pagination.totalResults) {
      return;
    }
    var el = document.body;
    if (el && (el.scrollHeight - window.innerHeight - el.scrollTop)/el.scrollHeight < 0.2) {
      this.loadNextPage();
    }
  }

  loadNextPage() {
    let offset = this.props.pagination.offset + this.props.pagination.limit;
    if(offset <= this.state.requestedOffset) {return;}
    this.setState({
      loading: true,
      requestedOffset: offset
    });
    this.context.executeAction(StoreActions.list, {
      filters: this.props.filters,
      sorter: this.props.sorter,
      pagination: _.extend({}, this.props.pagination, {offset: offset})
    });
  }

  renderStores() {
    let stores = this.props.stores.toList().map(store => {
      let storeCardProps = {
        key: store.get('id'),
        store: store
      };
      return <StoreCard {...storeCardProps} />;
    });
    return (
      <div className={styles.storesList}>
        {stores}
      </div>
    );
  }

  render() {
    let helmetProps = {
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'},
      ]
    };

    let numBottles = this.props.stats ? formatNumber(this.props.stats.distinct_wine_sku_ids) : '';

    return (
      <div className={styles.container}>
        <h2 className={styles.header}>Shop {numBottles} bottles from top wine stores</h2>
        <h3 className={styles.subheader}>The world’s best wine from America’s best merchants. Delivered to your door.</h3>
        {this.renderStores()}
      </div>
    );
  }
}

MarketingStoresListContainer = connectToStores(MarketingStoresListContainer, [InventoryRecordStore, StoreStore], (context, props) => {
  let storeStoreState = context.getStore(StoreStore).getCurrentState();
  return {
    stats: context.getStore(InventoryRecordStore).getStats(),
    stores: storeStoreState.entities,
    loading: storeStoreState.loading,
    filters: storeStoreState.filters,
    sorter: storeStoreState.sorter,
    pagination: storeStoreState.pagination
  };
});

export default MarketingStoresListContainer;

function formatNumber(num) {
  return (num + '').replace(/(\d)(?=(\d{3})+$)/g, '$1,');
}



// WEBPACK FOOTER //
// banquet/containers/MarketingStoresListContainer/index.js